module.exports = __webpack_public_path__ + "img/RECREATION_SAMEACTION.d9dd95af.png";